export const SearchIndexes = {
    Articles: 'blogpost',
    Products: 'product',
    Professionals: 'professional',
    Projects: 'project',
} as const;

/**
 * @todo Merge with `SearchIndex` in `@modules/search/type/api`.
 */
export type SearchIndexes = (typeof SearchIndexes)[keyof typeof SearchIndexes];
